import React, {Component} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toast} from 'primereact/toast';
import {Button} from 'primereact/button';
import {Toolbar} from 'primereact/toolbar';
import {Dialog} from 'primereact/dialog';
import {I18n, Translate} from "react-redux-i18n";
import {ContextMenu} from "primereact/contextmenu";
import {Order} from "../helpers/order";
import {connect} from "react-redux";
import BusinessService from "../services/BusinessService";
import ManageBusiness from "./ManageBusiness";
import {setBusinessListAction} from "../actions/business";

class Business extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            first: 0,
            pageSize: 5,
            totalRecords: 0,
            elements: [],
            element: null,
            elementDialog: false,
            deleteElementDialog: false,
            selectedElement: null,
            menuModel: [],
            sortFilterValues: [],
            loadingDialog: false,
            searchFilterValue: '',
            sortFilterValue: null,
        };

        this.elementService = new BusinessService();
        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
        this.onPage = this.onPage.bind(this);
        this.confirmDeleteElement = this.confirmDeleteElement.bind(this);
        this.deleteElement = this.deleteElement.bind(this);
        this.confirmDeleteSelected = this.confirmDeleteSelected.bind(this);
        this.hideDeleteElementDialog = this.hideDeleteElementDialog.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    componentDidMount() {
        this.createOptions();
        this.elementService.getPage(0, this.state.pageSize, this.state.sortFilterValue).then(
            response => {
                this.setState({
                    elements: response.data.content.list ? response.data.content.list : [],
                    totalRecords: response.data.content.totalCount,
                    loading: false
                })
            }
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.locale !== this.props.locale) {
            this.createOptions();
        }
    }

    createOptions() {
        const menuModel = [
            {
                label: I18n.t('EDIT_DATA'),
                icon: 'pi pi-fw pi-pencil',
                command: () => this.setState({
                    elementDialog: true,
                    element: this.state.selectedElement
                })
            },
            {
                label: I18n.t('DELETE_DATA'),
                icon: 'pi pi-fw pi-trash',
                command: () => this.confirmDeleteElement(this.state.selectedElement)
            }
        ];

        const sortFilterValues = [
            {name: I18n.t('ARTIST_NAME') + ' ' + I18n.t('ASCENDING'), field: 'artistName', order: Order.ASC},
            {name: I18n.t('ARTIST_NAME') + ' ' + I18n.t('DESCENDING'), field: 'artistName', order: Order.DESC}
        ];
        this.setState(({
            menuModel,
            sortFilterValues
        }));
    }

    onPage(event) {
        this.setState({loading: true});
        const {page, first, rows} = event;
        this.elementService.getPage(page, rows, this.state.sortFilterValue, this.state.searchFilterValue).then(
            response => {
                this.setState({
                    first,
                    elements: response.data.content.list ? response.data.content.list : [],
                    totalRecords: response.data.content.totalCount,
                    loading: false
                })
            }
        );
    }

    hideDeleteElementDialog() {
        this.setState({deleteElementDialog: false});
    }

    onComplete(res) {
        let element = res.data;
        if (element === null) {
            this.setState({
                elementDialog: false,
            });
            return
        }
        let elements = [...this.state.elements];
        this.setState({
            loadingDialog: true,
        });
        if (res.update === true) {
            //may be update
            const index = this.findIndexByIdentifier(element.identifier);
            elements[index] = element;
            console.log('uppppp-----',element)
            this.setState({
                elements,
                elementDialog: false,
                loadingDialog: false,
                element: this.emptyElement,
            });
        } else { //may be creation
            elements.unshift(element);
            this.setState({
                elements,
                elementDialog: false,
                loadingDialog: false,
                element: this.emptyElement,
                totalRecords: this.state.totalRecords + 1,
            });
        }
        this.props.dispatch(setBusinessListAction(this.state.elements));
    }

    confirmDeleteElement(element) {
        this.setState({
            element,
            deleteElementDialog: true
        });
    }

    deleteElement() {
        this.setState({
            loadingDialog: true,
        });
        this.elementService.delete(this.state.element.identifier)
            .then(() => {
                let elements = this.state.elements.filter(val => val.identifier !== this.state.element.identifier);
                this.setState({
                    elements,
                    deleteElementDialog: false,
                    element: this.emptyElement,
                    totalRecords: this.state.totalRecords - 1,
                    loadingDialog: false
                });
                this.toast.show({
                    severity: 'success',
                    summary: I18n.t('DELETION'),
                    detail: I18n.t('DELETION_SUCCESSFUL'),
                    life: 6000
                });
                this.props.dispatch(setBusinessListAction(this.state.elements));
            })
            .catch(error => {
                this.setState({
                    deleteElementDialog: false,
                    element: this.emptyElement,
                    loadingDialog: false
                });
                this.toast.show({
                    severity: 'error',
                    summary: I18n.t('DELETION'),
                    detail: I18n.t(error.response.data.code),
                    life: 6000
                });
            });
    }

    findIndexByIdentifier(identifier) {
        let index = -1;
        for (let i = 0; i < this.state.elements.length; i++) {
            if (this.state.elements[i].identifier === identifier) {
                index = i;
                break;
            }
        }
        return index;
    }

    confirmDeleteSelected() {
        this.setState({deleteElementsDialog: true});
    }

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <Button label={I18n.t('ADD_DATA')} icon="pi pi-plus" className="p-button-success p-mr-2"
                        onClick={() => this.setState({
                            elementDialog: true
                        })}/>
            </React.Fragment>
        )
    }

    render() {
        const header = (
            <div className="table-header">
                <h5 className="p-m-0">{I18n.t('BUSINESS')}</h5>
            </div>
        );
        const deleteElementDialogFooter = (
            <React.Fragment>
                <Button loading={this.state.loadingDialog} label={I18n.t('NO')} icon="pi pi-times"
                        className="p-button-text" onClick={this.hideDeleteElementDialog}/>
                <Button loading={this.state.loadingDialog} label={I18n.t('YES')} icon="pi pi-check"
                        className="p-button-text" onClick={this.deleteElement}/>
            </React.Fragment>
        );

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2"
                            onClick={() => this.setState({
                                element: rowData,
                                elementDialog: true
                            })}/>
                </React.Fragment>
            );
        }


        return (
            <div className="crud-demo">
                <Toast ref={(el) => this.toast = el}/>
                <ContextMenu model={this.state.menuModel} ref={el => this.cm = el}
                             onHide={() => this.setState({selectedElement: null})}/>
                <div className="card">
                    <Toolbar className="p-mb-4" left={this.leftToolbarTemplate} />
                    <DataTable ref={(el) => this.dt = el} value={this.state.elements}
                               dataKey="id" paginator lazy loading={this.state.loading} responsive
                               contextMenuSelection={this.state.selectedElement}
                               onContextMenu={e => this.cm.show(e.originalEvent)}
                               onContextMenuSelectionChange={e => this.setState({selectedElement: e.value})}
                               rows={this.state.pageSize} totalRecords={this.state.totalRecords}
                               first={this.state.first} onPage={this.onPage}
                               selectionMode="single"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               currentPageReportTemplate={I18n.t('PAGE_REPORT_TEMPLATE')}
                               header={header}>
                        <Column field="identifier" header={I18n.t('BUSINESS_ID')}/>
                        <Column field="name" header={I18n.t('BUSINESS_NAME')}/>
                        <Column field="type" header={I18n.t('BUSINESS_SUBSCRIPTION_TYPE')}/>
                        <Column headerStyle={{width: '3rem'}} body={actionBodyTemplate}/>
                    </DataTable>
                </div>

                <Dialog visible={this.state.deleteElementDialog} style={{width: '450px'}}
                        header={I18n.t('CONFIRMATION')} modal footer={deleteElementDialogFooter} closable={false}
                        onHide={this.hideDeleteElementDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        {this.state.element &&
                            <Translate dangerousHTML value="DELETE_ONE_WARNING" name={this.state.element.name}/>}
                    </div>
                </Dialog>

                <ManageBusiness show={this.state.elementDialog} onComplete={this.onComplete}
                                element={this.state.element}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const locale = state.i18n.locale;
    return {
        locale
    };
}

export default connect(mapStateToProps)(Business);


